<template>
  <div class="ResearchSelect-container">
    <el-select
      v-model="value"
      ref="select"
      placeholder="请选择调查问卷，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchCourse"
      :disabled="disabled"
      :style="tcfstyle"
      @clear="clearSelect">
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%">
          <el-table-column
            label="问卷标题"
            min-width="100"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span><i class="el-icon-document-checked"></i> <b>{{scope.row.title}}</b></span>
            </template>
          </el-table-column>
          <el-table-column
            label="问卷描述"
            width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="color:#99a9bf">描述：</span>
              <span>{{scope.row.desc}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="添加时间"
            align="center"
            width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span><i class="el-icon-time"></i> {{scope.row.time}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="创建人"
            align="center"
            width="140"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span><i class="el-icon-user"></i> {{scope.row.username}}</span>
            </template>
          </el-table-column>
<!--          <el-table-column-->
<!--            label="权限类型"-->
<!--            align="center"-->
<!--            width="180">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.ispub===0">公开</span>-->
<!--              <span v-if="scope.row.ispub===1">仅组织</span>-->
<!--              <span v-if="scope.row.ispub===2">仅经销商</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-select>
  </div>
</template>

<script>
import { getResearchById, getResearchList } from '@/api/work'

export default {
  name: 'ResearchSelect',
  props: {
    oldrid: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    },
    groupid: {
      type: Number
    },
    role: {
      type: Number
    },
    delid: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: ''
    }
  },
  created() {
    this.getData()
    if (this.oldrid !== null && this.oldrid !== '' && this.oldrid !== undefined) {
      getResearchById({ rid: this.oldrid }).then(response => {
        this.value = response.data.rid
        this.changeLabel = response.data.title
        this.$emit('input', { rid: response.data.rid })
      }).catch(() => {})
    }
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        content: this.filterText,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.groupid,
        role: this.role,
        delid: this.delid
      }
      getResearchList(data).then(response => {
        this.loading = false
        this.tableData = response.data.data
        this.total = response.data.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', null)
    },
    searchCourse(val) {
      this.filterText = val
      this.getData()
    },
    openDetails(data) {
      this.value = data.rid
      this.changeLabel = data.title
      this.$emit('input', { rid: data.rid })
      // this.$emit('setCourse', data)
      this.$refs.select.blur()
    }
  }
}
</script>
<style lang="scss" scoped>
  .ResearchSelect-container{
    .el-table::before{
      height: 0!important;
    }
    .el-pagination{
      margin-top: 20px;
    }
  }
</style>
